// Ignore Alpine.js cancelled transition errors (expected behavior when
// users interact quickly with elements using x-transition)
window.addEventListener(
  "unhandledrejection",
  (event) => {
    if (event.reason?.isFromCancelledTransition) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  },
  true,
);

// Import Alpine and plugins first

import Collapse from "@alpinejs/collapse";
import Morph from "@alpinejs/morph";
import Alpine from "alpinejs";

window.Alpine = Alpine;
Alpine.plugin(Collapse);
Alpine.plugin(Morph);

// Register sidebar flyout components
import { initializeSidebar, registerSidebarFlyoutComponents } from "./sidebar";

registerSidebarFlyoutComponents(Alpine);

// Import htmx setup before other modules
import "./htmx/htmx.js";

// Import styles
import "../css/app.css";
import "../css/activity_report.css";
import "../css/company_tracking_status.css";
import "../css/notes.css";
import "../css/tabulator_professional.css";
import "../css/ckeditor-widget.css";

// Tabulator stability patch (forces renderVertical: "basic" and guards resize recursion)
import "./tabulator_patch.js";

// Import and initialize Flowbite
import * as flowbite from "flowbite";

window.initFlowbite = flowbite.initFlowbite;

// Import custom datepicker initialization (prevents Flowbite year parsing bug)
import { initDatepickers } from "./datepicker-init";

window.initDatepickers = initDatepickers;

// Import other modules
import { manualScreenerTableFormatters } from "./stock_screener/ManualScreenerTableFormatters";

window.manualScreenerTableFormatters = manualScreenerTableFormatters;

import "./dark-mode";
import "./sweetalert2";
import "./storage/screenerStorage";
import "./hijack.js";
import "./tabulator_helpers.js";
import "./ckeditor/CKEditorManager";
import { initializeInlineStylePriorityGuards } from "./ckeditor/InlineStylePriorityGuard";

// Expose Highcharts theme utilities globally for inline template scripts
import "./common/chartThemeGlobal";

// Company detail charts (IRR decomposition waterfall, etc.)
import "./companies";

// Note: chatbots module is in its own separate bundle (chatbots.js)
// loaded only on the chat page for better performance

// Start Alpine and initialize sidebar after everything is loaded
document.addEventListener("DOMContentLoaded", () => {
  initializeInlineStylePriorityGuards(document);
  initializeSidebar();
  Alpine.start();
});

document.addEventListener("htmx:afterSettle", (event) => {
  const container = event.target instanceof Element ? event.target : document;
  initializeInlineStylePriorityGuards(container);
});
